<template>
  <main class="row pt-3 mx-0">
    <b-col
      lg="10"
      offset-lg="1"
    >
      <div class="d-flex flex-row align-items-baseline">
        <h1 class="mb-4 mr-2">
          {{ $t('Company') }}
        </h1>
        <span
          v-if="company.is_expedition_company"
          class="text-orange"
        >
          {{ $t("forwarder") }}
        </span>
      </div>
      <b-row>
        <b-col
          v-for="it in companyFields"
          :key="it.label"
          lg="4"
        >
          <dx-form-group
            v-if="it.isShown"
            :label="it.label"
          >
            <dx-text-box
              v-model="company[it.key]"
              value-change-event="input"
              styling-mode="outlined"
            />
          </dx-form-group>
        </b-col>
        <b-col
          v-if="!company.is_expedition_company"
          lg="3"
        >
          <dx-form-group :label="$t('freight forwarding contract date')">
            <dx-date-box
              v-model="company.freight_forwarding_contract_date"
              date-serialization-format="yyyy-MM-dd"
              type="date"
              class="w-100"
              styling-mode="outlined"
            />
          </dx-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="it in companyFields2"
          :key="it.label"
          :lg="it.size"
        >
          <dx-form-group
            v-if="it.isShown"
            :label="it.label"
          >
            <dx-text-box
              v-model="company[it.key]"
              value-change-event="input"
              styling-mode="outlined"
            />
          </dx-form-group>
        </b-col>
      </b-row>
      <dx-form-group
        v-if="!company.is_expedition_company"
        :label="$t('notification to client')"
      >
        <dx-text-box
          v-model="company.notification_msg"
          value-change-event="input"
          styling-mode="outlined"
        />
      </dx-form-group>
      <div
        v-if="!company.is_expedition_company"
        class="d-flex flex-row align-items-center mb-4"
      >
        <div class="dx-field-label dx-field-label--fit mr-2 mb-0">
          {{ $t('debtor') }}
        </div>
        <dx-check-box v-model="company.debtor" />
      </div>
      <div class="d-flex flex-row align-items-baseline">
        <dx-button
          :text="$t('Save')"
          :toolbar-items="false"
          type="success"
          styling-mode="contained"
          class="custom-btn mr-2"
          :disabled="loading"
          @click="onSubmit"
        />
        <!--        <router-link-->
        <!--          v-if="!company.is_expedition_company"-->
        <!--          :to="`/company-services/${id}`"-->
        <!--          class="text-uppercase"-->
        <!--          style="font-size: 13px"-->
        <!--        >-->
        <!--          {{ $t('Personal service price') }}-->
        <!--        </router-link>-->
      </div>
      <template v-if="isEdit">
        <h3 class="mt-4">
          {{ $t('company_employees') }}
        </h3>
        <user-list
          :data-source="userList"
          local-storage="company-users-grid-storage"
          :company-id="id"
          :company="company"
          :user-selected-id="userSelectedId"
        />
        <template v-if="!company.is_expedition_company">
          <h3 class="mt-4">
            {{ $t('Company managers') }}
          </h3>
          <dx-data-grid
            ref="managersGrid"
            :data-source="companyManagerList"
            :on-editor-preparing="onEditorPreparing"
            :show-borders="true"
            @toolbar-preparing="onToolbarPreparing"
          >
            <dx-column
              data-field="manager_id"
              :caption="$t('Username')"
            >
              <dx-lookup
                :data-source="commonManagerList"
                value-expr="id"
                display-expr="username"
              />
            </dx-column>
            <dx-column
              data-field="manager.first_name"
              :caption="$t('First name')"
              :allow-editing="false"
            />
            <dx-column
              data-field="manager.last_name"
              :caption="$t('Last name')"
              :allow-editing="false"
            />
            <dx-editing
              v-if="user.is_administrator"
              :allow-adding="true"
              :allow-deleting="true"
              :use-icons="true"
              mode="row"
            />
          </dx-data-grid>
          <related-users :id="id" />
        </template>
      </template>
      <dx-popup
        :visible.sync="popupVisible"
        :show-title="false"
        :drag-enabled="false"
        :show-close-button="false"
        :close-on-outside-click="true"
        width="500"
        height="140"
      >
        <div class="d-flex flex-column justify-center">
          <p class="mx-auto mt-2 mb-3">
            Организация с таким ИНН уже существует. Добавить?
          </p>
          <div class="d-flex flex-row">
            <dx-button
              :text="$t('Yes')"
              type="success"
              styling-mode="contained"
              class="custom-btn mr-2"
              width="100%"
              :disabled="loading"
              @click="onSubmit"
            />
            <dx-button
              :text="$t('No')"
              type="normal"
              styling-mode="contained"
              class="custom-btn mr-2"
              width="100%"
              @click="popupVisible = false"
            />
          </div>
        </div>
      </dx-popup>
    </b-col>
  </main>
</template>

<script>
import { DxDataGrid, DxColumn, DxEditing, DxLookup } from 'devextreme-vue/data-grid';
import { DxButton, DxTextBox, DxDateBox, DxCheckBox } from 'devextreme-vue'; // eslint-disable-line
import { DxPopup } from 'devextreme-vue/popup';

import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import DxFormGroup from '@/components/common/DxFormGroup';
import UserList from '@/components/UserList';
import RelatedUsers from '@/components/company/RelatedUsers';

import createCustomStore from '@/utils/create-custom-store';
import mixinDetictingMobile from '@/mixins/mixin-detecting-mobile';

export default {
  name: 'Company',
  components: {
    UserList,
    RelatedUsers,
    DxButton,
    DxTextBox,
    DxDateBox,
    DxCheckBox,
    DxFormGroup,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
    DxPopup,
  },
  mixins: [mixinDetictingMobile],
  props: {
    id: [String, Number],
    formType: String,
    userSelectedId: [String, Number],
  },
  data() {
    return {
      userList: [],
      companyManagerList: [],
      company: {
        debtor: false,
        inn: '',
        name: '',
        notification_msg: '',
        freight_forwarding_contract: '',
        freight_forwarding_contract_date: null,
      },
      loading: false,
      companyCreatedId: null,
      commonManagerList: createCustomStore('/profile/api/managers/'),
      companyExists: false,
      popupVisible: false,
    };
  },
  computed: {
    ...mapState(['user']),
    isEdit() {
      return this.formType === 'edit';
    },
    companyFields() {
      return [
        {
          key: 'name',
          label: this.$t('Organization name'),
          isShown: true,
        },
        {
          key: 'freight_forwarding_contract',
          label: this.$t('freight forwarding contract'),
          isShown: !this.company.is_expedition_company,
        },
      ];
    },
    companyFields2() {
      return [
        {
          key: 'address',
          label: this.$t('Address'),
          isShown: true,
          size: 6,
        },
        {
          key: 'address_for_sending_mail',
          label: this.$t('address_for_sending_mail'),
          isShown: true,
          size: 6,
        },
        {
          key: 'phone',
          label: this.$t('Phone'),
          isShown: true,
          size: 5,
        },
        {
          key: 'email',
          label: this.$t('Email'),
          isShown: true,
          size: 5,
        },
        {
          key: 'inn',
          label: this.$t('INN'),
          isShown: true,
          size: 4,
        },
        {
          key: 'ogrn',
          label: this.$t('ogrn'),
          isShown: true,
          size: 4,
        },
        {
          key: 'kpp',
          label: this.$t('kpp'),
          isShown: true,
          size: 4,
        },
        {
          key: 'bank_bic',
          label: this.$t('bank_bic'),
          isShown: true,
          size: 4,
        },
        {
          key: 'bank_checking_account',
          label: this.$t('bank_checking_account'),
          isShown: true,
          size: 4,
        },
        {
          key: 'bank_correspondent_account',
          label: this.$t('bank_correspondent_account'),
          isShown: true,
          size: 4,
        },
      ];
    },
  },
  watch: {
    id(val, prev) {
      if (!prev && val) {
        this.userList = createCustomStore(`/profile/api/companies/${this.id}/users/`);
        this.companyManagerList = createCustomStore(`/profile/api/companies/${this.id}/managers/`);
        this.getCompany();
      }
    },
  },
  async created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);

    if (this.isEdit) {
      this.userList = createCustomStore(`/profile/api/companies/${this.id}/users/`);
      this.companyManagerList = createCustomStore(`/profile/api/companies/${this.id}/managers/`);
      this.getCompany();
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        if (this.isEdit) {
          await this.$http.patch(`profile/api/companies/${this.company.id}/`, this.company);
          this.getCompany();
        } else {
          const { results } = await this.$http.get('/profile/api/companies/');
          this.companyExists = !!results.find(company => ((company.inn === this.company.inn)));
          if (this.companyExists && !this.popupVisible) {
            this.popupVisible = true;
          } else {
            const { id } = await this.$http.post('profile/api/companies/', this.company);
            this.$router.push(`/company/edit/${id}`);
            if (this.popupVisible) {
              this.popupVisible = false;
            }
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async getCompany() {
      this.company = await this.$http.get(`/profile/api/companies/${this.id}/`);
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-refresh',
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.managersGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.managersGrid.instance.clearFilter();
    },
    /* eslint-disable */
    onEditorPreparing: e => {
      const component = e.component;
      const rowIndex = e.row && e.row.rowIndex;
      if (e.dataField === 'manager_id') {
        const onValueChanged = e.editorOptions.onValueChanged;
        e.editorOptions.onValueChanged = evt => {
          setTimeout(() => {
            const manager = e.lookup.items.find(it => it.id === evt.value);
            onValueChanged.call(this, evt);
            component.cellValue(rowIndex, 'manager.first_name', manager.first_name);
            component.cellValue(rowIndex, 'manager.last_name', manager.last_name);
          }, 0);
        };
      }
    },
  },
};
</script>

<style lang="scss">
.dx-field-label--fit {
  width: fit-content !important;
}
</style>
